/* RESPONSIBLE TEAM: team-standalone */

import type AppService from 'embercom/services/app-service';
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import { taskFor } from 'ember-concurrency-ts';
import type FinStandaloneService from 'embercom/services/fin-standalone-service';

export default class DataRoute extends Route {
  @service declare finStandaloneService: FinStandaloneService;
  @service declare appService: AppService;

  async beforeModel() {
    let promises: Promise<void>[] = [];

    promises.push(this.appService.mainStandalonePlatform.loadDataFields());

    // TODO: SA Generic platform migration – Remove SFDC logic when data loading moved to the platform object
    if (this.appService.app.hasStandalonePlatform('salesforce')) {
      if (
        taskFor(this.finStandaloneService.salesforceDataLoader.loadSalesforceDataFields).isRunning
      ) {
        promises.push(
          taskFor(this.finStandaloneService.salesforceDataLoader.loadSalesforceDataFields)
            .lastRunning!,
        );
      } else {
        promises.push(
          taskFor(
            this.finStandaloneService.salesforceDataLoader.loadSalesforceDataFields,
          ).perform(),
        );
      }
    }

    // we call load data fields in the finStandaloneService.initialize method
    // but we are not returning them in the returned promise list
    // the intention here is to wait for these promises to resolve before
    // we navigate to this route
    await Promise.all(promises);
  }
}
